module.exports = __webpack_public_path__ + "img/oppo-bk.f7496b8f.svg";